module.exports = __webpack_public_path__ + "img/icon-lock.fa0ee657.svg";